import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProjectPage from "../pages/project/page";
import ProjectListPage from "../pages/project-list/page";
import BlogPage from "../pages/blog/page";
import BlogListPage from "../pages/blog-list/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/projects",
    element: <ProjectListPage />,
  },
  {
    path: "/project/:id",
    element: <ProjectPage />,
  },
  {
    path: "/blog",
    element: <BlogListPage />,
  },
  {
    path: "/blog/:id",
    element: <BlogPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
